export default __webpack_public_path__ + "static/media/hht1_song_11.5e7ddcb7.png";